import React, { ReactElement } from "react";
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { actions as baselineActions } from '@Actions/baselineActions';

import Notification from "@Components/Common/Notification";

import './ImportOptions.scss';

interface ImportOptionsProps {
    onSelectImportType: (importType: string) => void;
};

const ImportOptions = (props: ImportOptionsProps): ReactElement => {
    const dispatch: Dispatch = useDispatch();

    const importTemplate = async (templateType: string) => dispatch(baselineActions.importTemplate(templateType));

	const onDownload = async (templateType: string) => {
		importTemplate(templateType).then((error) => {
			if (error) {
				Notification('error', '', error);
			}
		});
	};

    return <div className='row'>
        <div className='col'>
            <div className='import-panel'>
                <div className='import-panel-header'>How will teams complete this project?</div>
                <div className='import-panel-body'>
                    <div className='import-options'>
                        <div className='import-option' onClick={() => props.onSelectImportType('relative')}>
                            <div className='option-header'>
                                Pacer will auto-calculate task dates based on your project's end date.
                            </div>
                            <div className='option-body'>
                                <div className='option-body-title'>
                                    Use <b>Relative</b> Date (T-minus)
                                </div>
                                <div className='option-body-content'>
                                    <button type='button' className='btn btn-link' onClick={() => onDownload('relative')}>
                                        Excel Import Tool
                                    </button>
                                </div>
                                <div className='option-body-recommended'>Recommended</div>
                            </div>
                        </div>
                        <div className='import-option' onClick={() => props.onSelectImportType('static')}>
                            <div className='option-header'>
                                All teams will complete all project tasks on the exact same dates/timeline.
                            </div>
                            <div className='option-body'>
                                <div className='option-body-title'>
                                    Use <b>Static</b> Date
                                </div>
                                <div className='option-body-content'>
                                    <button type='button' className='btn btn-link' onClick={() => onDownload('static')}>
                                        Excel Import Tool
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>;
};

export default ImportOptions;